import { render } from "./Ziarat.vue?vue&type=template&id=657f1020"
import script from "./Ziarat.vue?vue&type=script&lang=js"
export * from "./Ziarat.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__